export const CONNECTED_TURNAROUND_TEST_IDS = {
  composer: {
    question: 'connectedTurnaround.composer.input.question',
    send: 'connectedTurnaround.composer.button.send',
    stop: 'connectedTurnaround.composer.button.stop',
  },
  launcher: {
    toggle: 'connectedTurnaround.launcher.button.toggle',
  },
  messages: {
    error: 'connectedTurnaround.messages.text.error',
    retry: 'connectedTurnaround.messages.button.retry',
    row: (index: number) => `connectedTurnaround.messages.row.${index}`,
    status: 'connectedTurnaround.messages.view.status',
    thinking: 'connectedTurnaround.messages.view.thinking',
    unsupported: 'connectedTurnaround.messages.text.unsupported',
  },
  panel: {
    close: 'connectedTurnaround.panel.button.close',
    disclaimer: 'connectedTurnaround.panel.text.disclaimer',
    expand: 'connectedTurnaround.panel.button.expand',
    resize: 'connectedTurnaround.panel.view.resize',
    view: 'connectedTurnaround.panel.view.chat',
  },
} as const;
